"use client";
import type { SearchData } from "front-search-schema/algolia";
import { useEffect } from "react";
import { replaceAll } from "../_utils/searchStore";
import type { ConfigValue, FixedValue, ProductListValues, SelectedValue, Value } from "../_utils/types";

type Props = {
  values: Array<Value>;
  fixedValues: Array<Array<FixedValue>>;
  configValues: Array<ConfigValue>;
  productListValues: ProductListValues | null;
  term: string;
  selectedValue: SelectedValue | null;
  data: SearchData;
};
export const ReplaceAll = ({
  values,
  fixedValues,
  configValues,
  productListValues,
  term,
  selectedValue,
  data,
}: Props) => {
  useEffect(() => {
    replaceAll(values, fixedValues, configValues, productListValues, term, selectedValue, data);
  }, [values, fixedValues, configValues, productListValues, term, selectedValue, data]);

  return null;
};
